<div *ngIf="data$ | async as data" class="dashboard-chart-wrapper">
  <p-chart
    [type]="type"
    [data]="data"
    [options]="options"
    [plugins]="plugins"
    (onDataSelect)="onDataSelect($event)"
    style="width: 100%; height: 100%"
  >
  </p-chart>
</div>
